<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.75 19.6426C21.75 19.8415 21.671 20.0323 21.5303 20.1729C21.3897 20.3136 21.1989 20.3926 21 20.3926H3C2.80109 20.3926 2.61032 20.3136 2.46967 20.1729C2.32902 20.0323 2.25 19.8415 2.25 19.6426V4.64258C2.25 4.44367 2.32902 4.2529 2.46967 4.11225C2.61032 3.9716 2.80109 3.89258 3 3.89258C3.19891 3.89258 3.38968 3.9716 3.53033 4.11225C3.67098 4.2529 3.75 4.44367 3.75 4.64258V14.8323L8.46937 10.112C8.53903 10.0422 8.62175 9.9869 8.71279 9.94916C8.80384 9.91142 8.90144 9.89199 9 9.89199C9.09856 9.89199 9.19616 9.91142 9.28721 9.94916C9.37825 9.9869 9.46097 10.0422 9.53063 10.112L12 12.5823L16.9397 7.64258H15C14.8011 7.64258 14.6103 7.56356 14.4697 7.42291C14.329 7.28226 14.25 7.09149 14.25 6.89258C14.25 6.69367 14.329 6.5029 14.4697 6.36225C14.6103 6.2216 14.8011 6.14258 15 6.14258H18.75C18.9489 6.14258 19.1397 6.2216 19.2803 6.36225C19.421 6.5029 19.5 6.69367 19.5 6.89258V10.6426C19.5 10.8415 19.421 11.0323 19.2803 11.1729C19.1397 11.3136 18.9489 11.3926 18.75 11.3926C18.5511 11.3926 18.3603 11.3136 18.2197 11.1729C18.079 11.0323 18 10.8415 18 10.6426V8.70289L12.5306 14.1732C12.461 14.2429 12.3783 14.2983 12.2872 14.336C12.1962 14.3737 12.0986 14.3932 12 14.3932C11.9014 14.3932 11.8038 14.3737 11.7128 14.336C11.6217 14.2983 11.539 14.2429 11.4694 14.1732L9 11.7029L3.75 16.9529V18.8926H21C21.1989 18.8926 21.3897 18.9716 21.5303 19.1122C21.671 19.2529 21.75 19.4437 21.75 19.6426Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsChartLine'
})

defineProps({
  fill: {
    type: String,
    default: '#671CC2'
  }
})
</script>
